import React, { useRef, useState } from "react";

const SearchBar = ({ value = "", onChange, onSearch, onClear, isLoading = false }) => {
  const inputRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!value.trim()) return;
    inputRef.current?.blur();
    onSearch?.();
  };

  const hasText = value.trim().length > 0;

  return (
    <form className="search-wrapper" onSubmit={handleSubmit} role="search">
      <div
        className={`search-container ${
          isFocused ? "search-container--active" : ""
        }`}
      >
        {/* Search Icon */}
        <i className="bi bi-search search-left-icon"></i>

        {/* Input */}
        <input
          ref={inputRef}
          type="text"
          value={value}
          aria-label="Search content"
          placeholder="Search topics, exams, and more"
          onChange={(e) => onChange?.(e.target.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
        />

        {/* Clear */}
        {hasText && (
          <button
            type="button"
            className="search-clear"
            onClick={() => { onClear?.(); inputRef.current?.blur(); }}
            aria-label="Clear search"
          >
            <i className="bi bi-x"></i>
          </button>
        )}
      </div>

      {/* Right Search Button */}
      <button
        type="submit"
        className={`search-button ${
          hasText ? "search-button--active" : "search-button--disabled"
        }`}
        disabled={!hasText || isLoading}
        aria-label="Submit search"
      >
        <i className="bi bi-search"></i>
      </button>
    </form>
  );
};

export default SearchBar;
